import React from 'react'
import Header from '@/components/Header'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function CgvPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-24 pb-16 max-w-3xl mx-auto px-6 md:px-12">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm text-[#f5f5f7]/50 hover:text-[#f5f5f7] transition-opacity duration-[180ms] mb-8"
        >
          <ArrowLeft size={16} />
          Retour
        </button>

        <h1 className="text-3xl sm:text-4xl tracking-tight font-bold text-[#f5f5f7] font-heading mb-2">
          Conditions Générales de Vente
        </h1>
        <p className="text-sm text-[#f5f5f7]/40 mb-10">Dernière mise à jour : avril 2026</p>

        <div className="prose-custom space-y-8">
          <section>
            <h2>1. Identification de la société</h2>
            <p>
              Le site <strong>leasingmalin.com</strong> est édité et exploité par la société <strong>WeDreamTeam</strong>, SAS au capital de [à compléter] euros.
            </p>
            <ul>
              <li>SIRET : [à compléter]</li>
              <li>Siège social : [adresse à compléter]</li>
              <li>Email de contact : contact@leasingmalin.com</li>
              <li>Directeur de la publication : Fayçal Zouaoui</li>
            </ul>
          </section>

          <section>
            <h2>2. Description du service</h2>
            <p>
              LeasingMalin propose un service d'analyse de contrats de leasing automobile (LOA et LLD).
              L'utilisateur transmet son contrat via la plateforme. Notre système analyse le document et détermine
              si une économie sur les mensualités est envisageable.
            </p>
            <p>
              <strong>Le scan et l'analyse sont gratuits.</strong> Si aucune économie n'est détectée, l'utilisateur ne paie rien.
            </p>
          </section>

          <section>
            <h2>3. Les offres</h2>
            <p>Lorsqu'une économie est détectée, l'utilisateur peut choisir parmi deux formules :</p>

            <h3>Offre Essentiel</h3>
            <ul>
              <li><strong>Tarif :</strong> 20 € (frais fixes) + 5 % de l'économie annuelle détectée</li>
              <li><strong>Livrable :</strong> un email contenant le rapport d'analyse détaillé, la méthode de négociation pas à pas et les arguments personnalisés à présenter au bailleur</li>
              <li>L'utilisateur négocie lui-même avec son organisme de leasing</li>
            </ul>

            <h3>Offre Sérénité</h3>
            <ul>
              <li><strong>Tarif :</strong> 20 € (frais fixes) + 15 % de l'économie annuelle détectée</li>
              <li><strong>Livrable :</strong> prise en charge complète des démarches de négociation par Fayçal Zouaoui, fondateur de LeasingMalin, via un mandat signé par l'utilisateur</li>
              <li><strong>Garantie :</strong> si la négociation n'aboutit pas à une réduction effective, le pourcentage (15 % de l'économie annuelle) est remboursé intégralement. Seuls les 20 € de frais fixes restent dus</li>
            </ul>
          </section>

          <section>
            <h2>4. Conditions de paiement</h2>
            <p>
              Le paiement intervient uniquement lorsqu'une économie a été détectée et que l'utilisateur a choisi une formule.
              Le règlement s'effectue en ligne par carte bancaire via la plateforme sécurisée Stripe.
            </p>
            <p>
              Aucun paiement n'est demandé tant que l'utilisateur n'a pas consulté le résultat de l'analyse
              et choisi volontairement de souscrire à une offre.
            </p>
          </section>

          <section>
            <h2>5. Politique de remboursement</h2>
            <h3>Offre Essentiel</h3>
            <p>
              Le livrable étant un contenu numérique (email avec instructions), aucun remboursement n'est prévu
              après envoi du rapport, conformément à l'article L. 221-28 du Code de la consommation.
            </p>
            <h3>Offre Sérénité</h3>
            <p>
              Si la négociation menée par LeasingMalin n'aboutit pas à une réduction effective des mensualités
              auprès de l'organisme de leasing, la commission variable (15 % de l'économie annuelle) est remboursée
              intégralement à l'utilisateur. Les frais fixes de 20 € ne sont pas remboursables, car ils couvrent
              le temps d'analyse et de préparation du dossier.
            </p>
            <p>
              Le remboursement est effectué dans un délai de 14 jours ouvrés par le même moyen de paiement utilisé
              lors de la souscription.
            </p>
          </section>

          <section>
            <h2>6. Responsabilités et limites</h2>
            <p>
              LeasingMalin fournit une analyse et des recommandations basées sur les informations contenues dans le
              document transmis par l'utilisateur. L'exactitude de l'analyse dépend de la qualité et de l'exhaustivité
              du document fourni.
            </p>
            <p>
              LeasingMalin ne garantit pas l'obtention effective d'une réduction auprès de l'organisme de leasing.
              La décision finale de renégociation appartient exclusivement au bailleur ou à l'organisme financier.
            </p>
            <p>
              LeasingMalin ne se substitue pas à un conseiller juridique ou financier. Les recommandations fournies
              ne constituent pas un conseil juridique.
            </p>
          </section>

          <section>
            <h2>7. Droit de rétractation</h2>
            <p>
              Conformément aux articles L. 221-18 et suivants du Code de la consommation, l'utilisateur dispose
              d'un délai de <strong>14 jours</strong> à compter de la souscription pour exercer son droit de rétractation,
              sans avoir à justifier de motif ni à supporter de pénalités.
            </p>
            <p>
              Ce droit ne s'applique pas si le livrable numérique a été intégralement fourni avant l'expiration
              du délai de rétractation et que l'utilisateur a expressément consenti à renoncer à ce droit.
            </p>
            <p>
              Pour exercer votre droit de rétractation, envoyez un email à <strong>contact@leasingmalin.com</strong> en
              indiquant votre nom, la date de souscription et votre demande de rétractation.
            </p>
          </section>

          <section>
            <h2>8. Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu du site leasingmalin.com (textes, design, logos, analyses) est la propriété
              de WeDreamTeam et est protégé par le droit de la propriété intellectuelle. Toute reproduction,
              même partielle, est interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2>9. Litiges et droit applicable</h2>
            <p>
              Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'engagent à
              rechercher une solution amiable avant toute action judiciaire.
            </p>
            <p>
              À défaut de résolution amiable, le litige sera porté devant les tribunaux compétents du ressort
              du siège social de WeDreamTeam. Conformément à l'article L. 612-1 du Code de la consommation,
              le consommateur peut recourir gratuitement au service de médiation de la consommation.
            </p>
          </section>

          <section>
            <h2>10. Modification des CGV</h2>
            <p>
              WeDreamTeam se réserve le droit de modifier les présentes CGV à tout moment. Les conditions
              applicables sont celles en vigueur au moment de la souscription par l'utilisateur.
            </p>
          </section>
        </div>
      </main>
    </div>
  )
}
